import React from 'react';
import {observer} from 'mobx-react';
import {logged_in} from '../auth';
import openDesktopBrowser from '../openDesktopBrowser.js';
import {active_vm_frame, active_perm} from '../activeVM.js';
import {wifiController} from '../rpiClient/WifiController';
import {soundController, microphoneController} from '../rpiClient/AudioController';
import {displayController} from '../rpiClient/DisplayController';
import {app_settings, settingsController} from '../SettingsController.js';
import {web_entrypoint, is_whitelabel} from '../consts.js';
import {user_id, user_whitelabel_status, show_chat, is_managed, disabled_share_view, active_vm_is_camera_capable} from '../userData';
import { printerController } from '../rpiClient/PrinterController';
import { openZendeskChat } from "../zendesk.js";
import { CopilotButton } from './CopilotButton';
import VoiceButton from './VoiceButton';
import {openLayoutEditor, multimon_available, triggerGuacFullscreen} from '../webconnect/multimon.js';
import {can_capture_reserved_keys, enter_real_fullscreen} from '../webconnect/keyboardLock.js';
import MultiMonitorIcon from './MultiMonitorIcon';
import useTopbarOverflow from './useTopbarOverflow';


const renderOpenInButton = () => {
  if (!window.isRPi && (!is_whitelabel && !user_whitelabel_status.get())) {
    // Determine button text based on platform and user management status
    let buttonText;
    if (window.isElectron) {
      buttonText = is_managed.get() || user_id.get() === undefined  ? "Open in Browser" : "Open Admin Dashboard";
    } else {
      buttonText = "Open in Desktop";
    }
    const iconClass = window.isElectron ? "fa fa-window-maximize" : "fa fa-desktop";

    if (!window.isElectron || (window.isElectron && web_entrypoint)) {
      return (
        <div style={{height: '100%', display: 'inline-flex', alignItems: 'center'}}>
          <button type="button" className="btn control-buttons open-desk" onClick={openDesktopBrowser}>
            <i className={iconClass} aria-hidden="true" style={{verticalAlign: 'middle'}}></i> {buttonText}
          </button>
        </div>
      );
    }
  }
  
  return null;
}

export default observer(() => {

  const {rowRef, leftRef, rightRef, menuRef} = useTopbarOverflow();

  return (

  <div className="the-topbar" style={{height: '100%',  overflow: 'visible'}}>
     <div className="container-fluid" style={{padding: 0}}>
        <div className="topbar-row" ref={rowRef} style={{display: 'flex'}}>
           <div className="topbar-left" ref={leftRef} style={{display: 'inline-block'}}>

             {
               // Only show when logged in
               logged_in.get() &&

               // Never show in the share screen
               !window.location.href.includes('/share/') &&

                <div className="no-drag" style={{height: '100%', marginLeft: '20px', display: 'inline-block', verticalAlign: 'top', width: '15px', position: 'relative'}}>
                 <div id="the-menu-trigger" onClick={() => window.$('body').toggleClass('menu-open')}>
                    <span className="line line-1"></span>
                    <span className="line line-2"></span>
                    <span className="line line-3"></span>
                 </div>
                </div>

              }
              <div className="the-title no-drag" style={{visibility: (user_id.get() === null || (is_whitelabel || user_whitelabel_status.get())) ? 'hidden' : 'visible'}}>
                 V2 Cloud
              </div>
              {renderOpenInButton()}
           </div>

           <div className="topbar-right" ref={rightRef} style={{display: 'inline-flex', flexGrow: '1', alignItems: 'center', flexDirection: 'row-reverse'}}>

              <WindowButtons/>

              {( user_id.get() !== null && ((!is_whitelabel && !user_whitelabel_status.get()) || active_vm_frame.get())) &&

                <div className="no-drag" id="mobile-toggle-button" onClick={() => window.$('body').toggleClass('list-open')}>
                   <span className="sr-only">Menu</span>
                   <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                </div>

              }
              <ul className="list-horizontal aux-buttons" id="the-menu-items" ref={menuRef}>
                {active_vm_frame.get() && <VMButtons />}
                {user_id.get() !== null && (
                  <>
                    {!is_whitelabel && !user_whitelabel_status.get() && (
                      <li>
                        <button
                          type="button"
                          className="btn control-buttons"
                          data-toggle="modal"
                          onClick={() => {
                            const tutorialLink = window.isElectron
                              ? window.api.open_link_external("https://v2cloud.com/tutorials")
                              : "https://v2cloud.com/tutorials";
                            window.open(tutorialLink, '_blank').focus();
                          }}
                        >
                          <i className="fa fa-book" aria-hidden="true"></i> Tutorials
                        </button>
                      </li>
                    )}
                    <li>
                      <VoiceButton />
                    </li>
                    {show_chat.get() && (
                      <li className="live-help-button blobs-container" onClick={() => openZendeskChat()}>
                        <button type="button" className="btn control-buttons live-help-button-v2" id="live-help">
                          <i className="fa fa-user" style={{ color: "#00438b" }} aria-hidden="true"></i> Live help
                        </button>
                      </li>
                    )}
                  </>
                )}
              </ul>
              { window.isElectron && logged_in.get() && <RDPToggle/> }
           </div>
        </div>
     </div>
  </div>

  );

})


const RDPToggle = observer(() =>

  <>
    <button className="btn control-buttons custom-control custom-switch custom-switch-1" style={{paddingLeft: "2rem"}}>
        <input type="checkbox" className="custom-control-input" id="customSwitches1"
          checked={app_settings.get().useRDP}
          onChange={e => settingsController.setOptionByValue('useRDP', e.currentTarget.checked)}/>
        <label className="custom-control-label" htmlFor="customSwitches1">Use RDP</label>
    </button>
  </>

);

const VMButtons = observer(() => (

  <>

     <li>
        <button type="button" className="btn control-buttons make-full-screen-window" onClick={() => {
          window.$('body').toggleClass('full-screen');
      		window.$('body').removeClass('sub-menu-open');
      		window.$('body').removeClass('menu-open')
      		window.$('body').removeClass('list-open');
          window.$('body').trigger("full-screen-change");

          if(window.isElectron) {
            window.api.set_fullscreen(true);
          } else if(can_capture_reserved_keys()) {
            // Real fullscreen plus a keyboard lock, so Escape and the other
            // browser-reserved keys reach the VM instead of leaving fullscreen.
            enter_real_fullscreen(document.body);
          }
          // Anything that cannot capture reserved keys keeps the
          // body.full-screen class above as the whole effect, a CSS maximize.
          // That includes Safari, which has the Fullscreen API but no Keyboard
          // Lock. Escape is never intercepted outside fullscreen, so the VM
          // keeps receiving it.

          // Make this connection's secondary windows follow into fullscreen.
          triggerGuacFullscreen(true);

        }}>
        <i className="fa fa-arrows-alt" aria-hidden="true"></i> Full screen
        </button>
     </li>

     { multimon_available.get() &&
     <li>
        <button type="button" className="btn control-buttons make-multi-monitor" onClick={() => openLayoutEditor()}>
        <MultiMonitorIcon color="white" style={{height: '1.2em', width: '1.2em', display: 'inline-block'}} /> Monitors
        </button>
     </li>
     }

     {  (!is_whitelabel && !user_whitelabel_status.get()) && // This modal has branded content
       <li>
          <button type="button" className="btn control-buttons" data-toggle="modal" data-target="#transfer-files">
          <i className="fa fa-cloud-upload" aria-hidden="true"></i> Transfer files
          </button>
       </li>
     }
      { (!disabled_share_view.get()) &&
     <li>
        <button type="button" className="btn control-buttons" data-toggle="modal" data-target="#share-screen-popup">
        <i className="fa fa-share-alt" aria-hidden="true"></i> Share screen
        </button>
     </li>
      }
     
     { active_vm_is_camera_capable() &&
     <li>
        <button type="button" className="btn control-buttons" onClick={() => {
          const iframe = active_vm_frame.get();
          if (!iframe) return;

          // Toggle the webconnect extension's camera menu via postMessage
          iframe.contentWindow.postMessage({ type: 'v2cToggleCameraPopup' }, '*');
        }}>
          <i className="fa fa-video-camera" aria-hidden="true"></i> Cameras
        </button>
     </li>
     }

     {/* Copilot — renders only when copilot_enabled flag is on; no-op otherwise */}
     <CopilotButton permissionId={active_perm.get()} />

  </>

))

const WindowButtons = observer(() => {

  if(!window.isElectron) return null;

  if(window.isRPi)
    return (
    <>
      <div className="btn-group">
        <button type="button" className="btn" data-toggle="dropdown" style={{background:"#00438b", border: "none"}}>
          <i className="fa fa-power-off" aria-hidden="true" style={{color:'white'}}></i>
        </button>
        <div className="dropdown-menu dropdown-menu-right mt-1">
          <button className="dropdown-item" type="button"
            onClick={() => window.api.reboot()}
            > <i className="fa fa-repeat pr-3" aria-hidden="true" style={{color: "#00438b"}}></i> Reboot</button>
          <button className="dropdown-item" type="button"
            onClick={() => window.api.powerOff()}
            ><i className="fa fa-power-off pr-3" aria-hidden="true" style={{color: "#00438b"}}></i> Shutdown</button>
          <div className="dropdown-divider"></div>
          <button className="dropdown-item" type="button"
            onClick={() => window.api.updateApp()}
            ><i className="fa fa-refresh pr-3" aria-hidden="true" style={{color: "#00438b"}}></i> Check for Update</button>
        </div>
      </div>

      <ul className="list-inline pr-3">
        <li>
          <button type="button" className="btn" data-toggle="modal" data-target="#setup-display" onClick={() => displayController.loadCurrentDisplaySettings()}>
            <i className="fa fa-television" style={{color:"white"}} aria-hidden="true"></i>
            </button>
        </li>
        <li>
          <button type="button" className="btn" data-toggle="modal" data-target="#settings-modal"
            onClick={ () => {
                soundController.scan();
                microphoneController.scan();
                !printerController.status !== 'scanning' && printerController.scan();
              }
            }
          >
            <i className="fa fa-cog p-0" style={{color:"white"}} aria-hidden="true"></i>
          </button>
        </li>
        <li>
          <button type="button" className="btn" onClick={() => wifiController.scanWifis()} data-toggle="modal" data-target="#setup-wifi">
            <img src={wifiController.iconStatus} alt="" className="top-icon"/>
          </button>
        </li>
      </ul>
    </>
    );

  return (
    <ul className="list-inline">
      <li><button type="button" className="btn" onClick={() => window.api.minimize()}><i className="fa fa-window-minimize" aria-hidden="true"></i></button></li>
      <li><button type="button" className="btn" onClick={() => window.api.toggle_maximize()}><i className="fa fa-window-maximize" aria-hidden="true"></i></button></li>
      <li><button type="button" className="close-button btn" onClick={() => window.api.close()}><i className="fa fa-times" aria-hidden="true"></i></button></li>
    </ul>
  );

})
